import type {UseQueryOptions, UseQueryResult} from '@tanstack/react-query'
import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async'
import type {SchoolAdminAttrs} from '@freckle/school/ts/users/models/school-admin'
import {fetchSchoolAdmin} from '@freckle/school/ts/users/models/school-admin'

export function useSchoolAdmin(
  options?: Partial<UseQueryOptions<SchoolAdminAttrs>>,
): UseQueryResult<SchoolAdminAttrs> {
  const defaultOptions = {staleTime: 60 * 1000}
  return useAsync(fetchSchoolAdmin, 'fetchSchoolAdmin', [], {...defaultOptions, ...options})
}
